import { Box, Button, Typography, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';

import { Stack } from '@mui/system';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // import first
import { baseURL } from 'src/api/axios';
import CustomTextField from '../../../components/forms/theme-elements/CustomTextField';

const PasswordRegister = ({ title, subtitle, subtext }) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [matches, setMatches] = useState('');
  const [error, setError] = useState('');
  const [token, setToken] = useSearchParams();
  const theme = useTheme();


  useEffect(() => {
    if (confirmPassword.length && password.length) {
      if (confirmPassword === password) {
        setMatches(true);
      } else {
        if (matches) {
          setMatches(false);
        }
      }
    }
  }, [password, confirmPassword]);

  const submit = async () => {
    setError('');
    if (!matches) {
      setError('Passwords Dont Match');
      return;
    }
    try {
      let response = await axios.post(
        `${baseURL}/auth/reset-password/?token=${token.get('token')}`,
        {
          password,
        },
      );
      if (!response) {
        return;
      }

      let { status } = response;
      if (status < 202) {
        toast.success('Password Changed Successfully');
        setTimeout(() => {
          window.location.href = '/auth/login';
        }, 1500);
      } else {
        setError(response.response.data.message);
      }
    } catch (e) {
      console.log(e.message);
      setError('Something went wrong');
    }
  };
  return (
    <>
      {title ? (
        <Typography fontWeight="700" variant="h2" mb={1}>
          {title}
        </Typography>
      ) : null}

      {subtext}

      <Box>
        <Stack
          mb={3}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              submit();
            }
          }}
        >
          <Typography
            variant="subtitle1"
            fontWeight={600}
            component="label"
            htmlFor="password"
            mb="5px"
            mt="25px"
          >
            Password
          </Typography>
          <CustomTextField
            type="password"
            id="password"
            variant="outlined"
            fullWidth
            placeholder="Enter your Password"
            setState={setPassword}
          />
          <Typography
            variant="subtitle1"
            fontWeight={600}
            component="label"
            htmlFor="confirmpassword"
            mb="5px"
            mt="25px"
          >
            Confirm Password
          </Typography>
          <CustomTextField
            type="password"
            id="confirmpassword"
            variant="outlined"
            fullWidth
            placeholder="Confirm your password"
            setState={setConfirmPassword}
          />
        </Stack>
        <Button
          sx={{ bgcolor: theme.palette.earnpati.main, fontWeight: 'bold' }}
          variant="contained"
          size="large"
          fullWidth
          onClick={() => {submit()}}
        >
          Change Password
        </Button>
        <Typography
          variant="subtitle1"
          fontWeight={600}
          component="label"
          htmlFor="confirmpassword"
          mb="5px"
          mt="25px"
        >
          {matches && !error ? (
            <p style={{ color: 'green' }}>Password Matches</p>
          ) : error ? (
            <p style={{ color: 'red' }}>{error}</p>
          ) : null}
        </Typography>
        <ToastContainer />
      </Box>
      {subtitle}
    </>
  );
};

export default PasswordRegister;
